require('../../modules/es6.string.raw');
module.exports = require('../../modules/_core').String.raw;
